var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18.49 1.5"}},[_c('title',[_vm._v("minus")]),_c('line',{staticStyle:{"fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"},style:({stroke: _vm.color}),attrs:{"x1":"17.74","y1":"0.75","x2":"0.75","y2":"0.75"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }